import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

import { useTranslation } from 'hooks/useTranslation';

import { ReactComponent as SignUpSuccessIcon } from 'assets/icons/signup-success-icon.svg';

import { useStyles } from 'features/auth/components/SignUp/styles';
import BaseButton from 'features/app/components/BaseButton';
import React from 'react';
import { authPaths } from 'features/auth/routes/paths';
import { AuthPageLayout } from 'features/auth/components/AuthPageLayout';
import { Title } from 'shared';
import i18n from 'locales/i18n';

export const SuccessfulSignUp = () => {
  const { t } = useTranslation('auth');
  const direction = i18n.dir();
  const classes = useStyles({ isFirstPartOfSignUpShowed: false, direction });

  return (
    <>
      <Title title={t('signUp')} />
      <AuthPageLayout title={t('signUpSuccessMessageTitle')} additionalContentClassName={classes.signUpFormWrapper}>
        <Box>
          <Typography className={classes.successfulSignUpText}>{t('signUpSuccessMessageBody')}</Typography>
          <Box display="flex" justifyContent="center" alignItems="center">
            <SignUpSuccessIcon />
          </Box>
          <Box display="flex" justifyContent="center" alignItems="center">
            <BaseButton
              className={classes.backToHomepage}
              variant="contained"
              borderRadius={5}
              fullWidth
              to={authPaths.static.login}
            >
              {t('backToHomepage')}
            </BaseButton>
          </Box>
        </Box>
      </AuthPageLayout>
    </>
  );
};
